export const skillsData = {
  skills: [
    {
      title: "Python",
      progress: "75%",
    },
    {
      title: "SQL",
      progress: "75%",
    },
    {
      title: "React",
      progress: "65%",
    },
    {
      title: "Javascript",
      progress: "65%",
    },
    {
      title: "C/C++",
      progress: "45%",
    },
    {
      title: "HTML",
      progress: "90%",
    },
    {
      title: "CSS",
      progress: "80%",
    },
    {
      title: "Java",
      progress: "45%",
    },
  ],
  frameworks: [
    {
      title: "React.js",
      progress: "90%",
    },
    {
      title: "Flutter",
      progress: "85%",
    },
    {
      title: ".NET",
      progress: "70%",
    },
    {
      title: "Angular.js",
      progress: "65%",
    },
    {
      title: "Vue.js",
      progress: "60%",
    },
    {
      title: "Redux",
      progress: "80%",
    },
    {
      title: "Framer Motion",
      progress: "40%",
    },
    {
      title: "Photoshop / Figma / UI / UX",
      progress: "60%",
    },
    {
      title: "Django",
      progress: "50%",
    },
    {
      title: "Bootstrap",
      progress: "70%",
    },
  ],
  database: [
    {
      title: "AWS (S3, EC2, Lamda)",
      progress: "65%",
    },
    {
      title: "MongoDB (NoSQL)",
      progress: "70%",
    },
    {
      title: "Redis",
      progress: "50%",
    },
    {
      title: "PostgreSQL",
      progress: "70%",
    },
  ],
  Libraries: [
    {
      title: "PySpark",
      progress: "70%",
    },
    {
      title: "Keras",
      progress: "60%",
    },
    {
      title: "NumPy",
      progress: "80%",
    },
    {
      title: "Matplotlib",
      progress: "60%",
    },
    {
      title: "Tensorflow",
      progress: "60%",
    },
    {
      title: "Seaborn",
      progress: "40%",
    },
    {
      title: "Beautiful Soup",
      progress: "70%",
    },
    {
      title: "Sci-kit-Learn",
      progress: "70%",
    },
    {
      title: "PyTorch",
      progress: "70%",
    },
  ],
};

// Constants for experience details
export const EXPERIENCE_DETAILS = [
  {
    title: "Software Engineer",
    company: "Wipro Technologies",
    responsibilities: [
"Developed a real-time patient data pipeline using Java and ReactJS, reducing processing latency from 15 to 5min & designed HIPAA-compliant storage system in PostgreSQL with AES-256 encryption, reducing unauthorized access risks by 40%.",      "Developed a CRM solution using Force.com, integrating React for interactive lead dashboards and MongoDB to handle large customer datasets.",
      "Built a Spring Boot REST API integrated with ReactJS front-end, optimizing querying and filtering, cutting response time from 3s to 1s also created dashboards using ReactJS to monitor patient status and enhance user experience.",
      "Migrated a monolithic app to microservices using Spring Boot and Docker, enhancing scalability by 60%, reducing downtime by 75%, and developed CI/CD pipelines with Jenkins, Docker, and Kubernetes, cutting deployment failures by 45% and accelerating release cycles from 2 weeks to 5 days.",
      "Implemented asynchronous communication using RabbitMQ for event-driven messaging, processing 200k+ events per day for real-time patient updates across different healthcare facilities.",
      "Developed and executed unit tests using JUnit, ensuring the reliability of critical features in the data pipeline and REST API"
    ],
    duration: "Jan 2022 - Aug 2023",
  },
  {
    title: "Software Engineer Intern",
    company: "Wipro Technologies",
    responsibilities: [
      "Automated 10+ reports with Oracle BI Publisher, cutting manual effort by 30%, while collaborating across with with Project Managers, designers, and architects to design, implement, and test at the production level."
    ],
    duration: "Mar 2021 - Nov 2021",
  },
  {
    title: "Research Assistant with Prof. I.V Ramakrishnan",
    company:
      "Stony Brook Knowledge Systems Lab | Python, LLM, AWS, Django, AndroidStudio",
    responsibilities: [
      "Led AI-MedRec project for ED patients, NLP and LLMs and advanced technologies such as AWS Textract , Gemini, and GPT-4 to automate medication reconciliation, reducing errors by 15% and time by 25%.",
      "Development and deployment of Django API Android app for data access, showcasing full-stack and API integration skills.",
      "I led the development of a system to process large EMR and EHR datasets, using NLTK and SpaCy to extract meaningful medication data from clinical notes and records.",
      // "Organize College, National and International level events.",
    ],
    duration: "Jan 2024 - Present",
  },
  // Add more experience entries as needed
  {
    title: "RESEARCH EXPERIENCE",
    company:
      "Stony Brook Pace Lab | Data Analysis, Data visualization, Predictive modeling, Regression analysis",
    responsibilities: [
      "Quantified carbon cost savings and emissions reductions through statistical advanced analytics and predictive modeling for extending server lifetimes, including data pre-processing, querying data cleaning for data validation.",
      "Performed data analysis and visualization using programming language like Python, Pandas, and NumPy to process over 5,000 server carbon footprint data points, enhancing interpretability through 20+ graphs.",
      "Developed an ML model with accuracy of 80% in predicting impact of carbon footprint from data centers, validating real-world data.",
      // "Organize College, National and International level events.",
    ],
    duration: "Aug 2023 - Dec 2023",
  },
];

// Constants for education
export const EDUCATION_DETAILS = [
  {
    institution: "STONY BROOK UNIVERISTY",
    degree: "M.S. IN COMPUTER SCIENCE",
    subjects: "Visualization, Data Structures & Algorithms, Machine Learning",
    duration: "August 2023 - May 2025",
  },
  {
    institution: "KAKATIYA INSTITUTE OF TECHNOLOGY AND SCIENCE",
    degree: "B.TECH IN COMPUTER SCIENCE",
    subjects:
      "Theory of Computation, Theory of Database Systems, Operating Systems, Human Computer Interactions",
    duration: "August 2016 - September 2020",
  },
];

export const CONTACT_INFO = {
  location: "Stony Brook, New York, United States",
  phone: "+1 631-776-9877",
  formspreeUrl: "https://formspree.io/f/manywldz", //Need to change this -TO-DO- -VArun
  alertMessage: "Thanks {name}, I will shortly connect with you!",
  errorMessage: "Something went wrong!",
  placeholders: {
    name: "Enter your name",
    email: "Enter email",
    message: "Enter message",
  },
};

export const homeDPageDetails = {
  details:
    "Software Engineer with 3+ years of experience building full-stack web applications in Python, React, Node.js, and Django for healthcare and enterprise SaaS industries. Achieved a 40% boost in sales conversions and a 15% reduction in user-reported issues through CRM solutions. Led feature development to reduce onboarding time by 25% and improve data load times by 20%. Skilled in collaborating with cross-functional teams to deliver secure, high-performance systems that meet business goals and enhance user experience.",
};
